import {
  put,
  call,
  takeEvery,
} from 'redux-saga/effects';
import i18next from 'i18next';
import _ from 'lodash';
import {
  types,
  uploadFileError,
  uploadFileToCreateDocumentError,
  uploadFileToCreateDocumentSuccess,
} from 'generic/core/files/actions';
import { snackActions } from 'generic/utils/snackbar';
import { uploadFile } from 'generic/api/uploadFile';

function* workUploadFile({ params, file, uploadActions }) {
  let message;
  try {
    yield put(uploadActions.loading);
    const results = yield call(uploadFile, { fileUpload: true, uriParams: { ...params }, bodyItems: file });
    message = _.get(results, 'status');
    if (message === 'KO') {
      message = _.get(results, 'error.message');
      throw new Error(message);
    }
    const uploadActionSuccess = {
      ...uploadActions.success,
      results,
    };
    yield put(uploadActionSuccess);
  } catch (error) {
    yield put(uploadActions.error);
    yield put(uploadFileError(error));
    console.error(error);
    snackActions.error(message || i18next.t('ged.error_uploading_file'));
  }
}

function* watchUploadFile() {
  yield takeEvery(types.UPLOAD_FILE, workUploadFile);
}

function* workUploadFileToCreateDocument({ params, file, name }) {
  let message;
  try {
    const results = yield call(uploadFile, { fileUpload: true, uriParams: { ...params }, bodyItems: file });
    message = _.get(results, 'status');
    if (message === 'KO') {
      message = _.get(results, 'error.message');
      throw new Error(message);
    }
    yield put(uploadFileToCreateDocumentSuccess(name));
    snackActions.success(i18next.t('ged.uploading_file_success', { file: name }));
  } catch (error) {
    yield put(uploadFileToCreateDocumentError(name));
    console.error(error);
    snackActions.error(message || i18next.t('ged.error_uploading_file'));
  }
}

function* watchUploadFileToCreateDocument() {
  yield takeEvery(types.UPLOAD_FILE_TO_CREATE_DOCUMENT, workUploadFileToCreateDocument);
}

export default {
  watchUploadFile,
  watchUploadFileToCreateDocument,
};
